import { useContext } from 'react';

import { TopMenuContext } from './Context';

export const useGetExtraSection = () => {
  const context = useContext(TopMenuContext);

  if (!context) {
    throw new Error('useGetExtraSection must be used within TopMenuProvider');
  }

  return context.extraSection;
};
